/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import navigation from 'services/NavigationService';

import ActionDrawerStore from 'stores/ActionDrawerStore';
import { ComponentWithInjectedProps } from 'utils/injectedProps';

import styles from '../../../../ActionDrawer.module.scss';
import Loading from 'components/Loading/Loading';

type InjectedProps = {
  actionDrawerStore: ActionDrawerStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class DeleteEmailDomainSuccess extends ComponentWithInjectedProps<
  {},
  {},
  InjectedProps
> {
  componentDidMount() {
    const { actionDrawerStore } = this.props;

    setTimeout(() => {
      actionDrawerStore.closeActionDrawer();
    }, 1000);
  }

  render(): React.Node {
    const { t } = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div>
            <h3>{t('general:email_domains.delete_email_domain_success_title')}</h3>
            <p>{t('general:email_domains.messages.delete_email_domain_success')}</p>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
